import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { PdfToAudioDemoPage } from '@/components/astro/new-design-25/SEO/pdf-to-audio-demo-page';
import { hreflangLinks, seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/_seo/pdf-to-audio')({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'PDF to Audio Online — Free PDF Reader with AI Voices | Listening',
        description:
          'Convert PDF documents to natural audio with AI voices. Drop a PDF and open a 24-hour read-along link with PDF view, audio, and playback controls.',
      }),
    ],
    links: [...hreflangLinks('/pdf-to-audio')],
  }),
  component: PdfToAudioDemoPage,
});
